import React, { useEffect } from 'react';
import { TDR } from 'tdr-common';
import { analytics, MODAL_OPENED_EVENT } from '../../../helpers/analytics';
import { CTAButton } from '../../buttons';
import { ControlledDialog } from './ControlledDialog';
import { useTranslation } from 'react-i18next';

type ModificationUnavailableProps = {
	isOpen: boolean;
	onClose: () => void;
	onDismiss: () => void;
	restaurant: TDR.Restaurant;
};

export const ModificationUnavailable = ({ isOpen, onClose, onDismiss, restaurant }: ModificationUnavailableProps) => {
	const { t } = useTranslation();
	let body = (
		<>
			<span>
        We apologize for any inconvenience, but you are no longer able to modify or cancel this booking, as your booking is just around the corner.
			</span>
			<span>If you are unable to attend your scheduled booking, please call the restaurant directly {restaurant.phoneNumber ? (
				<>at <a href={`tel:${restaurant.phoneNumber}`} style={{ textDecoration: 'none' }}><strong>{restaurant.phoneNumber}</strong></a></>
			) : ''} to cancel.</span>
		</>
	);

	if (restaurant?.name) {
		body = (
			<>
				<span>
			We apologize for any inconvenience, but you are no longer able to modify or cancel this booking, as your arrival at{' '}
					<strong>{restaurant.displayName || restaurant.name}</strong> is just around the corner.
				</span>
				<span>If you are unable to attend your scheduled booking, please call the restaurant directly {restaurant.phoneNumber ? (
					<>at <a href={`tel:${restaurant.phoneNumber}`} style={{ textDecoration: 'none' }}><strong>{restaurant.phoneNumber}</strong></a></>
				) : ''} to cancel.</span>
			</>
		);
	}

	useEffect(() => {
		if (isOpen) {
			analytics.track(MODAL_OPENED_EVENT, { title: t('titles.modification_unavailable') });
		}
	}, [isOpen]);

	return (
		<ControlledDialog
			isOpen={isOpen}
			onClose={onClose}
			title={t('titles.modification_unavailable')}
			icon='error'
			body={body}
			footer={<CTAButton buttonText={t('actions.dismiss')} onClick={onDismiss} variant='dark' />}
		/>
	);
};
